<div class="product-list-item-grid h-100 px-1 d-flex flex-column">
  <div class="d-flex flex-column h-100 w-100 justify-content-start position-relative">
    <div class="promotagcontainer" [class.promotagcontainerlechaibg]="productListProduct.isWineShopProduct">
      @if (isAuthenticated && productListProduct.productTagList != undefined && productListProduct.productTagList.length > 0) {
        <app-product-tag-list [productTagList]="productListProduct.productTagList"></app-product-tag-list>
      }
    </div>

    <a [routerLink]="['/product', 'detail']" [queryParams]="{ productNumber: productListProduct.productIdentifier?.productNumber, quantityUnit: productListProduct.salesUnit?.quantityUnit }">
      <div class="gallery-image-container justify-content-center position-relative">
        <div class="w-100 h-100 d-flex justify-content-center" [class.lechaibg]="productListProduct.isWineShopProduct">
          <img class="w-100 h-100 w-max-300px h-max-300px obj-fit-contain obj-position-center thumbnail" [src]="productListProduct.thumbnail" alt="thumbnail" />
        </div>
      </div>
    </a>

    <span class="pictogramcontainer flex-row align-self-center">
      @if (productListProduct.productTagList != undefined && productListProduct.productTagList.length > 0) {
        <app-product-tag-pictogram [productTagList]="productListProduct.productTagList"></app-product-tag-pictogram>
      }
    </span>

    <div class="h-100 d-flex flex-column">
      <div class="d-flex my-1 justify-content-between w-100 gallery-button-container">
        @if (authService.isAuthenticated()) {
          <app-product-add-to-cart-template-icon [productIdentifier]="productListProduct.productIdentifier" [quantityUnit]="productListProduct.salesUnit" [quantity]="productListProduct.minimumOrderAmount"> </app-product-add-to-cart-template-icon>
        }

        @if (contextService.contextGet() == "myShop") {
          @if (authService.isAuthenticated() && productListProduct.isFavorite == true) {
            <div class="favorite-container">
              <app-product-favorite-icon [productIdentifier]="productListProduct.productIdentifier" [isFavorite]="productListProduct.isFavorite" (onFavoriteRemove)="onProductRemove.emit()"> </app-product-favorite-icon>
            </div>
          }
        }

        @if (shoppingCartItem == undefined) {
          <span>
            <app-price-card-price class="d-block flex-grow-1 align-self-end mx-2" [priceTemplateData]="productListProduct.priceTemplateData" [shouldAllowTextWrap]="true"> </app-price-card-price>
          </span>
        }

        @if (isAuthenticated != true) {
          <ng-container *ngTemplateOutlet="loginButton"></ng-container>
        }

        @if (isAuthenticated == true) {
          @if (productListProduct.productStockIsLoading == true || isLoading) {
            <ng-container *ngTemplateOutlet="loadingButton"></ng-container>
          }
          @if (productListProduct.productStockIsLoading != true && isLoading != true) {
            @if (productListProduct.priceTemplateData?.orderUnitPrice?.shouldDisplayPriceOnRequest == true) {
              <ng-container *ngTemplateOutlet="infoButton"></ng-container>
            }
            @if (productListProduct.priceTemplateData?.orderUnitPrice?.shouldDisplayPriceOnRequest != true) {
              @if (productListProduct.priceTemplateData?.orderPriceMark == ePriceMark.NoPrice) {
                <ng-container *ngTemplateOutlet="banButton"></ng-container>
              }

              @if (productListProduct.priceTemplateData?.orderPriceMark == undefined || productListProduct.priceTemplateData?.orderPriceMark != ePriceMark.NoPrice) {
                @switch (productListProduct.productStockInformation?.productAvailabilityState) {
                  @case (eProductAvailabilityState.Green) {
                    <ng-container *ngTemplateOutlet="cartButton; context: { $implicit: productListProduct }"></ng-container>
                  }
                  @case (eProductAvailabilityState.Yellow) {
                    <ng-container *ngTemplateOutlet="cartButton; context: { $implicit: productListProduct }"></ng-container>
                  }
                  @case (eProductAvailabilityState.Red) {
                    <ng-container *ngTemplateOutlet="notifyButton; context: { $implicit: productListProduct }"></ng-container>
                  }
                  @case (eProductAvailabilityState.Car) {
                    <ng-container *ngTemplateOutlet="notifyButton; context: { $implicit: productListProduct }"></ng-container>
                  }
                  @default {
                    <ng-container *ngTemplateOutlet="infoButton"></ng-container>
                  }
                }
              }
            }
          }
        }
      </div>

      <div class="d-flex flex-column justify-content-between flex-grow-1">
        <a class="description-container" [routerLink]="['/product', 'detail']" [queryParams]="{ productNumber: productListProduct.productIdentifier?.productNumber, quantityUnit: productListProduct.salesUnit?.quantityUnit }">
          <div class="overflow-hidden">
            <span class="fw-bold">{{ productListProduct.description }}</span>
          </div>
        </a>

        <div>
          <div class="product-attribute-row">
            @if (productListProduct.salesUnit?.quantityUnitCaption != undefined) {
              <div class="product-attribute">{{ productListProduct.salesUnit | quantityUnitToString }}</div>
            }

            <!-- hide packaging type in case it is the same as quantity unit -->
            @if (productListProduct.packagingType != undefined && (productListProduct.packagingType | packagingToStringPipe) != (productListProduct.salesUnit | quantityUnitToPluralString)) {
              <div class="product-attribute">{{ productListProduct.packagingType | packagingToStringPipe }}</div>
            }
          </div>

          <div class="mb-1">
            <span i18n="@@ProductListProductEntryItemNumber">Item # </span>
            <a [routerLink]="['/product', 'detail']" [queryParams]="{ productNumber: productListProduct.productIdentifier?.productNumber, quantityUnit: productListProduct.salesUnit?.quantityUnit }">{{
              productListProduct.productIdentifier?.productNumber
            }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #loadingButton>
  <button type="button" class="btn btn-secondary p-1 action" disabled>
    <app-loading-indicator-base [loadingIndicatorStyle]="eLoadingIndicatorStyle"></app-loading-indicator-base>
  </button>
</ng-template>

<ng-template #loginButton>
  <button type="button" class="btn btn-secondary p-1 action" [routerLink]="['/login']">
    <i class="bi bi-cart4 mx-1"></i>
  </button>
</ng-template>

<ng-template #cartButton let-productListProduct>
  @if (isShoppingCartDefined != true) {
    <ng-container *ngTemplateOutlet="createCartButton"></ng-container>
  }

  @if (isShoppingCartDefined == true) {
    @if (shoppingCartItem == undefined && !isExportBanned) {
      <ng-container *ngTemplateOutlet="addToCartButton; context: { $implicit: productListProduct }"></ng-container>
    }
    @if (shoppingCartItem == undefined && isExportBanned) {
      <ng-container *ngTemplateOutlet="banButton"></ng-container>
    }
    @if (shoppingCartItem != undefined) {
      <app-quantity-input-bare
        class="my-auto"
        [min]="minimumOrderAmount"
        [max]="maximumOrderAmount"
        [quantity]="shoppingCartItem.quantity"
        [accept]="acceptQuantityChangeTrigger.asObservable()"
        [reject]="rejectQuantityChangeTrigger.asObservable()"
        (onQuantityChanged)="quantityChangedAsync($event)"
        (onProductRemoveFromCart)="deleteFromCart()"
      >
      </app-quantity-input-bare>
    }
  }
</ng-template>

<ng-template #infoButton>
  <button type="button" class="btn btn-light p-1 action" disabled>
    <img role="img" src="assets/images/shoppingcart_slashed.png" class="cart-slashed" />
  </button>
</ng-template>

<ng-template #banButton>
  <button type="button" class="btn btn-light p-1 action" disabled>
    <img role="img" class="cart-slashed" src="assets/images/shoppingcart_slashed.png" />
  </button>
</ng-template>

<ng-template #createCartButton>
  <button type="button" class="btn btn-secondary p-1 action" (click)="createCartClickAsync()">
    <i class="bi bi-cart4 mx-1"></i>
  </button>
</ng-template>

<ng-template #addToCartButton let-productListProduct>
  <button type="button" class="btn btn-secondary p-1 action" (click)="addToCartClickAsync(productListProduct)">
    <i class="bi bi-cart4 mx-1"></i>
  </button>
</ng-template>

<ng-template #notifyButton let-productListProduct>
  @if (productListProduct.hasAvailabilityNotification != undefined) {
    @if (productListProduct.hasAvailabilityNotification != true) {
      <button type="button" class="btn btn-light p-1 action" (click)="availabilityNotificationCreateClickAsync(productListProduct)">
        <i class="bi bi-bell mx-1"></i>
      </button>
    }
    @if (productListProduct.hasAvailabilityNotification == true) {
      <button type="button" class="btn btn-light p-1 action" (click)="availabilityNotificationDeleteClickAsync(productListProduct)">
        <i class="bi bi-bell-slash mx-1"></i>
      </button>
    }
  }
  @if (productListProduct.hasAvailabilityNotification == undefined) {
    <ng-container *ngTemplateOutlet="infoButton"></ng-container>
  }
</ng-template>
